<script>
import Multiselect from 'vue-multiselect'
import UploadFile from '@components/upload-file'

export default {

    components: { Multiselect, UploadFile },

    props: {

    },

    data() {
        return {
            trackBy: 'operator_uuid',

            provider: null,
            initProvider: [],
            providers_option: [],

            model: null,
            initModel: [],
            models_option: [],

            knowledge: null,
            initKnowledge: [],
            knowledge_option: [],

        }
    },

    watch: {
        initProvider: {
            immediate: true,
            handler(values) {
                this.provider = this.providers_option.filter(x => values.includes(x[this.trackBy]));
                this.provider = this.provider[0];
            }
        },
        initModel: {
            immediate: true,
            handler(values) {
                this.model = this.models_option.filter(x => values.includes(x['id']));
                this.model = this.model[0];
            }
        },
        provider: {
            immediate: true,
            async handler(values) {

                if(this.provider){
                    this.$parent.ai_request_params.provider = this.provider.operator_code ? this.provider.operator_code : null;
                    this.$parent.ai_request_params.provider_uuid = this.provider.operator_uuid ? this.provider.operator_uuid : null;

                    let filter = {
                        'operator_uuid' : this.$parent.ai_request_params.provider_uuid,
                        'product_code'  : this.$parent.ai_request_params.product_code,
                    }
                    let data_send = {
                        'where' : JSON.stringify(filter)
                    }

                    await this.$store.dispatch('operatorsTariffs/FETCH_OPERATORS_TARIFFS_LIST', data_send);
                    this.models_option = this.operators_tariffs_list_data;

                    if(this.$parent.ai_request_params.id && this.$parent.ai_request_params.id) {
                        this.initModel = [this.$parent.ai_request_params.id];
                    }

                } else if(values === null) {
                    this.models_option = [];
                    this.model = null;
                    this.$parent.ai_request_params.provider = null;
                    this.$parent.ai_request_params.provider_uuid = null
                }
            }
        },
        model: {
            immediate: true,
            handler(values) {
                if(this.model && this.model.id) {
                    this.$parent.ai_request_params.id = this.model.id ? this.model.id : null;
                    this.$parent.ai_request_params.model = this.model.model ? this.model.model : null;
                } else if(values === null) {
                    this.$parent.ai_request_params.id = null;
                    this.$parent.ai_request_params.model = null;
                }
            }
        },
        initKnowledge: {
            immediate: true,
            handler(values) {
                this.knowledge = this.knowledge_option.filter(x => values.includes(x['uuid']));
                this.knowledge = this.knowledge[0];
            }
        },
        knowledge: {
            immediate: true,
            handler(values) {
                if(this.knowledge && this.knowledge.uuid) {
                    this.$parent.ai_request_params.knowledge_uuid = this.knowledge.uuid;
                } else if(values === null) {
                    this.$parent.ai_request_params.knowledge_uuid = null;
                }
            }
        },
    },

    computed: {
        operators_tariffs_list_data(){
            return this.$store.getters['operatorsTariffs/GET_OPERATORS_TARIFFS_LIST_DATA'];
        },
        knowledge_list_data(){
            return this.$store.getters['knowledge/GET_KNOWLEDGE_LIST_DATA'];
        },
    },

    async mounted() {

        let data_send = {
            'filter'     : this.$parent.params && this.$parent.params.ai_request_params && this.$parent.params.ai_request_params.product_code ? this.$parent.params.ai_request_params.product_code : this.$parent.ai_request_params.product_code,
            'filterOn'   : JSON.stringify(['product_code']),
            'get_fields' : JSON.stringify(['operator_code', 'operator_name', 'operator_uuid', 'product_code']),
            'groupBy'    : JSON.stringify(['operator_code', 'operator_name', 'operator_uuid', 'product_code']),
        }

        await this.$store.dispatch('operatorsTariffs/FETCH_OPERATORS_TARIFFS_LIST', data_send);

        this.providers_option = this.operators_tariffs_list_data;
        
        if(this.$parent.params.ai_request_params && this.$parent.params.ai_request_params.provider_uuid) {
            this.initProvider = [this.$parent.params.ai_request_params.provider_uuid];
        }

        await this.$store.dispatch('knowledge/FETCH_KNOWLEDGE_LIST', {});

        this.knowledge_option = this.knowledge_list_data;

        if(this.$parent.params.ai_request_params && this.$parent.params.ai_request_params.knowledge_uuid) {
            this.initKnowledge = [this.$parent.params.ai_request_params.knowledge_uuid];
        }
    },

    methods: {

    }
}
</script>

<template>
    <div>
        <b-form-group
            label="Провайдер"
            label-for="provider"
        >
            <multiselect
                id="provider"
                v-model="provider"
                :options="providers_option"
                placeholder="Выберите из списка"
                selectLabel="Нажмите, чтобы выбрать"
                deselectLabel="Нажмите, снять выделение"
                label="operator_name"
                :track-by="trackBy"
            ></multiselect>
        </b-form-group>

        <b-form-group
            label="Модель"
            label-for="model"
        >
            <multiselect
                id="model"
                v-model="model"
                :options="models_option"
                placeholder="Выберите из списка"
                selectLabel="Нажмите, чтобы выбрать"
                deselectLabel="Нажмите, снять выделение"
                label="name"
                track-by="id"
            ></multiselect>
        </b-form-group>

        <div class="row">
            <div class="col-sm-12 col-xl-12">
                <b-form-checkbox v-model="$parent.ai_request_params.clear_context" name="config_ai_request_params" style="margin-bottom: 15px" switch>
                    Очистить контекст
                </b-form-checkbox>
            </div>
        </div>

        <b-form-group
            label="Системная инструкция"
            label-for="system_message"
        >
            <b-form-textarea
                id="system_message"
                v-model="$parent.ai_request_params.system_message"
                rows="4"
            ></b-form-textarea>
        </b-form-group>

        <b-form-group
            label="Текст запроса"
            label-for="user_message"
        >
            <b-form-textarea
                id="user_message"
                v-model="$parent.ai_request_params.user_message"
                rows="4"
            ></b-form-textarea>
        </b-form-group>

        <div class="row">
            <div class="col-sm-12 col-xl-12">
                <b-form-checkbox v-model="$parent.ai_request_params.fl_knowledge" name="config_ai_request_params_fl_knowledge" style="margin-bottom: 15px"  switch>
                    Использовать базу знаний
                </b-form-checkbox>
            </div>
        </div>        

        <b-form-group
            v-if="$parent.ai_request_params.fl_knowledge"
            label="База знаний"
            label-for="knowledge"
        >
            <multiselect
                id="knowledge"
                v-model="knowledge"
                :options="knowledge_option"
                placeholder="Выберите из списка"
                selectLabel="Нажмите, чтобы выбрать"
                deselectLabel="Нажмите, снять выделение"
                label="name"
                track-by="uuid"
            ></multiselect>
        </b-form-group>

        <b-form-group
            v-if="$parent.ai_request_params.fl_knowledge"
            label="Текст запроса к базе знаний"
            label-for="knowledge_request"
        >
            <b-form-textarea
                id="knowledge_request"
                v-model="$parent.ai_request_params.knowledge_request"
                rows="2"
            ></b-form-textarea>
        </b-form-group>

        <div class="row">
            <div class="col-sm-12 col-xl-12">
                <b-form-checkbox v-model="$parent.ai_request_params.fl_request_classifier" name="config_ai_request_params_fl_request_classifier" style="margin-bottom: 15px"  switch>
                    Классифицировать запросы
                </b-form-checkbox>
            </div>
        </div>

        <b-form-group
            v-if="$parent.ai_request_params.fl_request_classifier"
            label="Промт на классификацию запроса"
            label-for="classifier_request"
        >
            <b-form-textarea
                id="classifier_request"
                v-model="$parent.ai_request_params.classifier_request"
                rows="4"
            ></b-form-textarea>
        </b-form-group>

        <div class="row">
            <div class="col-sm-12 col-xl-12">
                <b-form-checkbox v-model="$parent.ai_request_params.fl_answer_classifier" name="config_ai_request_params_fl_answer_classifier" style="margin-bottom: 15px"  switch>
                    Классифицировать ответы
                </b-form-checkbox>
            </div>
        </div>

        <b-form-group
            v-if="$parent.ai_request_params.fl_answer_classifier"
            label="Промт на классификацию ответа"
            label-for="classifier_answer"
        >
            <b-form-textarea
                id="classifier_answer"
                v-model="$parent.ai_request_params.classifier_answer"
                rows="4"
            ></b-form-textarea>
        </b-form-group>

        <div class="row">
            <div class="col-sm-12 col-xl-12">
                <b-form-checkbox v-model="$parent.ai_request_params.fl_summarizing" name="config_ai_request_params_fl_summarizing" style="margin-bottom: 15px"  switch>
                    Суммаризация
                </b-form-checkbox>
            </div>
        </div>

        <b-form-group
            v-if="$parent.ai_request_params.fl_summarizing"
            label="Промт на суммаризацию диалога"
            label-for="summarizing_request"
        >
            <b-form-textarea
                id="summarizing_request"
                v-model="$parent.ai_request_params.summarizing_request"
                rows="4"
            ></b-form-textarea>
        </b-form-group>

        <div class="row">
            <div class="col-sm-12">
                <b-form-group
                    label="Креативность"
                    label-for="ai_request_params_temperature"
                >
                    <b-form-input
                        id="ai_request_params_temperature"
                        v-model="$parent.ai_request_params.temperature"
                    ></b-form-input>
                </b-form-group>
            </div>
            <div class="col-sm-12">
                <b-form-group
                    label="Максимальная длина ответа в токенах"
                    label-for="ai_request_params_max_tokens"
                >
                    <b-form-input
                        id="ai_request_params_max_tokens"
                        v-model="$parent.ai_request_params.max_tokens"
                    ></b-form-input>
                </b-form-group>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12 col-xl-12">
                <b-form-checkbox v-model="$parent.ai_request_params.stream" name="config_ai_request_params_stream" style="margin-bottom: 15px"  switch>
                    Потоковая обработка
                </b-form-checkbox>
            </div>
        </div>

        <b-form-group
            label="Ответ записать в переменную"
            label-for="ai_request_params_variable"
        >
            <b-form-input
                id="ai_request_params_variable"
                v-model="$parent.ai_request_params.variable_name"
            ></b-form-input>
        </b-form-group>

    </div>
</template>
